import { render, staticRenderFns } from "./number-input.vue?vue&type=template&id=0973dca8&scoped=true&"
import script from "./number-input.vue?vue&type=script&lang=js&"
export * from "./number-input.vue?vue&type=script&lang=js&"
import style0 from "./number-input.vue?vue&type=style&index=0&id=0973dca8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0973dca8",
  null
  
)

export default component.exports